import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Someone finally figured out how to market on Twitter",
  "description": "",
  "published": "2011-07-25T00:00:00.000Z",
  "redirect_from": ["/blog/?p=1994"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Everyone can probably agree that marketing on twitter is quite prolific to say the least. That there are a bunch of people marketing. That there are almost more brands using it as there are people. Many people have a personal account and two, three, four brand accounts ... you know, because that one side project you did that weekend when you kind of had two beers too many and were hopped up on energy drinks ... yeah, that totally needs its own twitter account.`}</p>
    <p>{`Needless to say, Twitter is becoming increasingly annoying.`}</p>
    <p>{`Mostly because of clueless marketers. It's actually an awesome platform and I feel I've made many a meaningful connection on it.`}</p>
    <p>{`But the marketers.`}</p>
    <p>{`Dear fuck, the marketers!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      